module.exports = __webpack_public_path__ + "static/media/16.df7406e3.jpg";